export const FETCH_GAMES_REQUEST = 'FETCH_GAMES_REQUEST'
export const FETCH_GAMES_SUCCESS = 'FETCH_GAMES_SUCCESS'
export const FETCH_GAMES_FAILURE = 'FETCH_GAMES_FAILURE'
export const FETCH_GAMES_DETAILS_REQUEST = 'FETCH_GAMES_DETAILS_REQUEST'
export const FETCH_GAMES_DETAILS_SUCCESS = 'FETCH_GAMES_DETAILS_SUCCESS'
export const FETCH_GAMES_DETAILS_FAILURE = 'FETCH_GAMES_DETAILS_FAILURE'
export const FETCH_GAMES_TERMS_SUCCESS = 'FETCH_GAMES_TERMS_SUCCESS'